// Remembers the signed-in admin across reloads so the app shell can paint
// immediately instead of waiting on the network.
//
// On a reload, `onAuthStateChanged` does not fire until Firebase has validated
// the stored ID token — which means a round trip to securetoken.googleapis.com
// whenever the token is older than an hour — and only *then* does allRoutes
// read `admins/{uid}`, which additionally pays the Firestore/IndexedDB cold
// start. Both are serial, and the whole tree used to sit behind a bare
// "Authenticating" loader for the duration: commonly 0.6-3 seconds of blank
// screen on every single reload.
//
// This is an optimistic hint, never an authorisation decision. It lets the
// header, sidebar and page frame render right away; the real auth check still
// runs and still wins — if it comes back logged-out, the admin is cleared and
// PrivateLayout redirects to the login screen. Nothing sensitive is exposed by
// it either: every actual read is still gated by Firestore security rules,
// which answer to the token, not to this.

const CACHED_ADMIN_KEY = "algCachedAdmin";

export const readCachedAdmin = () => {
  try {
    const raw = localStorage.getItem(CACHED_ADMIN_KEY);
    if (!raw) return null;
    const admin = JSON.parse(raw);
    // A shape check, so a half-written or outdated entry can't render a broken
    // shell — the id is what everything downstream keys off.
    return admin && admin.id ? admin : null;
  } catch (error) {
    return null;
  }
};

export const writeCachedAdmin = (admin) => {
  try {
    if (admin && admin.id) {
      localStorage.setItem(CACHED_ADMIN_KEY, JSON.stringify(admin));
    } else {
      localStorage.removeItem(CACHED_ADMIN_KEY);
    }
  } catch (error) {
    // Storage full or blocked (private windows) — the app just loses the
    // head start, which is not worth surfacing.
  }
};
